import { STATS } from "../data/content";
import { Reveal } from "./Reveal";

const StatsStrip = () => (
  <section data-testid="clinical-stats-strip" className="border-y border-[#0D3B3E]/10 bg-white/60">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <Reveal
          key={s.label}
          delay={i * 0.08}
          data-testid={`stat-metric-card-${i}`}
          className={`py-10 sm:py-12 px-2 sm:px-6 ${i !== 0 ? "lg:border-l border-[#0D3B3E]/10" : ""} ${i % 2 !== 0 ? "border-l lg:border-l" : ""}`}
        >
          <p className="text-4xl sm:text-5xl font-display font-bold text-[#0D3B3E] tracking-tight">{s.value}</p>
          <p className="mt-3 text-[10px] sm:text-[11px] font-mono tracking-[0.2em] text-[#0D9488]">{s.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);

export default StatsStrip;
